var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInventoryDisposed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 4,
    fill: "#E5E5E5",
    stroke: "#252525",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7473_16128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 38.7599C20 42.2066 22.5987 45 25.8052 45H37.9939C38.8711 45 39.7023 44.7846 40.4481 44.4067C40.7963 43.6051 41 42.7116 41 41.7687V21H20V38.7634V38.7599Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5178 21.6162V39.774C41.5178 42.787 39.1117 45.2288 36.1428 45.2288H24.8573C21.8884 45.2288 19.4822 42.787 19.4822 39.774V21.6162",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4904 21.6155H19.5096C18.5423 21.6155 17.7605 20.819 17.7605 19.8405C17.7605 18.8588 18.5453 18.0654 19.5096 18.0654H41.4874C42.4547 18.0654 43.2365 18.8619 43.2365 19.8405C43.2365 20.8221 42.4517 21.6155 41.4874 21.6155H41.4904Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1827 18.3251V14.772H35.8173V18.3251",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1523 26.2891V38.2574",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26.2891V38.2574",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8477 26.2891V38.2574",
    stroke: "#252525",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7473_16128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 32,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventoryDisposed);
export default __webpack_public_path__ + "static/media/icon-inventory-disposed.c8e0c193a071f79fac41bff2e53646cf.svg";
export { ForwardRef as ReactComponent };